<template>
  <div class="wrapper">
    <b-overlay :show="isLoading" rounded="sm" @shown="onShown">
      <b-breadcrumb>
        <b-breadcrumb-item>YOU ARE HERE</b-breadcrumb-item>
        <b-breadcrumb-item>
          <router-link tag="a" to="/app/applications">
            Applications</router-link
          >
        </b-breadcrumb-item>
        <b-breadcrumb-item>{{ formName }}</b-breadcrumb-item>
        <b-breadcrumb-item active>{{ modulName }}</b-breadcrumb-item>
      </b-breadcrumb>
      <b-container fluid>
        <b-card>
          <template v-slot:header>
            <b-row>
              <b-col sm="auto" md="9">
                <div class="text-left">
                  <h4>Institution</h4>
                </div>
              </b-col>
              <b-col sm="auto" md="3">
                <div class="text-right">
                  <b-button
                    variant="success"
                    size="sm"
                    v-on:click="show = !show"
                    >Create</b-button
                  >
                </div>
              </b-col>
            </b-row>
          </template>
          <b-table
            responsive
            stickyColumn
            striped
            hover
            show-empty
            :per-page="paging.perPage"
            :current-page="paging.currentPage"
            :items="items"
            :fields="fields"
            head-variant="dark"
          >
            <template v-slot:cell(actions)="{ item }">
              <b-button
                title="Hapus"
                size="xs"
                variant="danger"
                v-on:click="deleteData(item.id)"
              >
                <b-icon icon="trash-fill" aria-label="Help"></b-icon>
              </b-button>
              <b-button
                title="Ubah"
                size="xs"
                variant="warning"
                v-on:click="editData(item.id, item.name)"
              >
                <b-icon icon="pencil-square" aria-label="Help"></b-icon>
              </b-button>
            </template>
          </b-table>
          <div class="mt-3">
            Showing {{ pageItems }} of {{ items.length }} entries
            <b-pagination
              v-model="paging.currentPage"
              :total-rows="rows"
              :per-page="paging.perPage"
              align="right"
            >
            </b-pagination>
          </div>
        </b-card>
        <template>
          <!-- <b-modal
            v-model="show"
            @ok="onSubmit()"
            @hidden="cancel()"
            ok-title="Save"
            cancel-title="Cancel"
            ok-variant="success"
            cancel-variant="warning"
            header-bg-variant="secondary"
            footer-bg-variant="secondary"
            hide-backdrop
            size="lg"
            ref="modal"
            no-close-on-backdrop
            title="Form Institution"
          > -->
          <b-modal
            v-model="show"
            ref="my-modal"
            header-bg-variant="secondary"
            footer-bg-variant="secondary"
            hide-backdrop
            size="lg"
            title="Form Institution"
          >
            <div id="modal">
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(onSubmit)">
                  <b-row>
                    <b-col cols="12">
                      <!-- Institution -->
                      <validation-provider
                        name="Institution"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group
                          label-cols="3"
                          label-cols-lg="3"
                          label-size="sm"
                        >
                          <template v-slot:label>
                            Institution Name<code>*</code>
                          </template>
                          <b-form-input
                            id="inputInstitution"
                            v-model="form.name"
                            :state="getValidationState(validationContext)"
                            trim
                          ></b-form-input>
                          <b-form-invalid-feedback id="inputInstitution">{{
                            validationContext.errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                      <!-- /Institution -->
                    </b-col>
                  </b-row>
                  <!-- penambahan terbaru -->
                  <b-row class="float-right">
                    <b-button class="mr-3" variant="success" @click="onSubmit()"
                      >Save</b-button
                    >
                    <b-button class="mr-3" variant="warning" @click="cancel()"
                      >Cancel</b-button
                    >
                  </b-row>
                </b-form>
              </validation-observer>
            </div>
            <template #modal-footer>
              <div class="h-300 bg-secondary"></div>
            </template>
          </b-modal>
        </template>
      </b-container>
      <template #overlay>
        <div ref="loadings" class="text-center">
          <b-icon
            icon="arrow-clockwise"
            font-scale="3"
            animation="spin"
          ></b-icon>
          <p id="cancel-label">Please wait...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { fnGET, fnPOST, fnPUT, fnDELETE } from "../../../../../api/api-methods";
import { APIPATH_DMS } from "../../../../../api/api-paths";
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      formName: "Institution",
      modulName: "Dashboard",
      items: [],
      fields: [
        { key: "actions", label: "#" },
        { key: "name", label: "Institution Name" },
        { key: "created_by", label: "Created By" },
        {
          key: "created_at",
          label: "Created At",
          formatter: this.setDateFormat,
        },
        { key: "modified_by", label: "Updated By" },
        {
          key: "modified_at",
          label: "Updated At",
          formatter: this.setDateFormat,
        },
      ],
      paging: {
        perPage: 10,
        currentPage: 1,
      },
      isLoading: false,
      form: {
        institution_id: null,
        name: null,
        created_by: null,
        modified_by: null,
        deleted_by: null,
      },
      show: false,
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),
    rows() {
      if (this.items) {
        return this.items.length;
      }
    },
    pageItems() {
      var totalPage = Math.ceil(this.rows / this.paging.perPage);
      if (this.paging.currentPage === totalPage) {
        return (
          (this.rows % this.paging.perPage) +
          this.paging.perPage * totalPage -
          this.paging.perPage
        );
      } else {
        return this.paging.perPage * this.paging.currentPage;
      }
    },
  },
  methods: {
    ...mapActions("session", ["showNotification"]),
    setDateFormat(value) {
      var options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      var formats = new Date(value).toLocaleDateString("id-ID", options);
      if (value) {
        return formats;
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getInstitution() {
      fnGET(APIPATH_DMS.getInstitution)
        .then((rsp) => {
          Vue.set(this, "items", rsp.data.payload);
        })
        .catch((err) => {
          return err;
        });
    },
    onSubmit() {
      Vue.set(this, "isLoading", true);
      if (this.form.institution_id) {
        fnPUT(APIPATH_DMS.putInstitution, this.form)
          .then((rsp) => {
            this.showNotification({
              type: "success",
              message: "Successfully Submitted",
            });
            Vue.set(this, "isLoading", false);
            this.getInstitution();
          })
          .catch((err) => {
            this.showNotification({
              type: "danger",
              message: "Failed Submitted, Something wrong",
            });
            Vue.set(this, "isLoading", false);
            return err;
          });
        this.cancel();
      } else {
        // var unique = this.validationUnique()

        // if (unique.length == 0) {
        fnPOST(APIPATH_DMS.postInstitution, this.form)
          .then((rsp) => {
            this.showNotification({
              type: "success",
              message: "Successfully Submitted",
            });
            Vue.set(this, "isLoading", false);
            this.getInstitution();
          })
          .catch((err) => {
            this.showNotification({
              type: "danger",
              message: "Failed Submitted, Something wrong",
            });
            Vue.set(this, "isLoading", false);
            return err;
          });
        this.cancel();
        // }else{
        //     Vue.set(this,'isLoading',false)
        //     alert('Duplicate!!!, Data already created')
        // }
      }
    },
    editData(id, name) {
      Vue.set(this, "show", true);
      Vue.set(this.form, "institution_id", id);
      Vue.set(this.form, "name", name);
    },
    deleteData(id) {
      this.$bvModal
        .msgBoxConfirm("Are you sure?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            Vue.set(this, "isLoading", true);
            fnPUT(APIPATH_DMS.deleteInstitution, { institution_id: id })
              .then((rsp) => {
                this.showNotification({
                  type: "success",
                  message: "Successfully Submitted",
                });
                Vue.set(this, "isLoading", false);
                this.getInstitution();
              })
              .catch((err) => {
                this.showNotification({
                  type: "danger",
                  message: "Failed Submitted, Something wrong",
                });
                Vue.set(this, "isLoading", false);
                return err;
              });
          }
        });
    },
    setUserData() {
      Vue.set(this.form, "created_by", this.userData.fullname);
      Vue.set(this.form, "modified_by", this.userData.fullname);
      Vue.set(this.form, "deleted_by", this.userData.fullname);
    },
    onShown() {
      // Focus the cancel button when the overlay is showing
      this.$refs.loadings.focus();
    },
    cancel() {
      Vue.set(this.form, "institution_id", null);
      Vue.set(this.form, "name", null);
      this.$refs["my-modal"].hide();
    },
    validationUnique() {
      var institusi = this.form.name.toLowerCase().trim();

      return this.items.filter((item) => {
        return item.name.toLowerCase().match(institusi);
      });
    },
  },
  created() {
    this.getInstitution();
    this.setUserData();
  },
};
</script>

<style>
</style>